import API from '../../lib/api'
import base from './base'

const api = new API(1, 'lots')
const baseModule = base(api);

baseModule.actions.update = (context, obj) => {
	return new Promise((resolve, reject) => {
		return api.put(obj.num, obj).then(res => {
			resolve(res)
			context.commit('update', obj)
		})
		.catch(err => {
			reject(err)
		})
	})
}

baseModule.actions.create = (context, obj) => {
	return new Promise((resolve, reject) => {
		api.post(obj).then(res => {
			resolve(res)
			obj.num = res
			context.commit('create', obj)
		})
		.catch(err => {
			reject(err)
		})
	})
}

baseModule.mutations.update = (state, obj) => {
	state.list.every((item, i) => {
		if(item.num === obj.num) {
			state.list.splice(i, 1, obj)
			return false
		}
		return true
	});
}

baseModule.actions.delete = (context, obj) => {
	return new Promise((resolve, reject) => {
		api.delete(obj.num).then(res => {
			resolve(res)
			context.commit('delete', obj)
		})
		.catch(err => {
			reject(err)
		})
	})
}

baseModule.mutations.delete = (state, obj) => {
	state.list.every((item, i) => {
		if(item.num === obj.num) {
			state.list.splice(i, 1)
			return false
		}
		return true
	});
}

export default {
	namespaced: true,
	state: baseModule.state,
	getters: baseModule.getters,
	actions: baseModule.actions,
	mutations: baseModule.mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/lots.js